import { useEffect, useState } from "react";
import sondertagService from "../services/sondertagService";
export default function useSonderEventTemplates() {
  const [sondertagTemplates, setSondertagTemplates] = useState([]);
  const [sonderEventTemplates, setSonderEventTemplates] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res1 = await sondertagService.getSondertagTemplates();
        setSondertagTemplates(res1);
        const res2 = await sondertagService.getSonderEventTemplates();
        setSonderEventTemplates(res2);
      } catch (err) {
        console.error("Error loading templates:", err);
      }
    };
    load();
  }, []);

  return {
    sondertagTemplates,
    sonderEventTemplates,
  };
}
